import { MenuItem, TextField } from "@mui/material";
import { IBuildlingBlockInputControl } from "./BuildingBlockInterfaces";

export interface UISelectProps extends IBuildlingBlockInputControl<string> {
    options: string[];
}

export function UISelect(props: UISelectProps) {
    return (
        <TextField
            label={props.label}
            select={true}
            sx={props.sx}
            value={props.value}
            onChange={(e) => {
                e.stopPropagation();
                e.preventDefault();
                props.onChange(e.target.value as string);
            }}
            variant={props.variant ?? "outlined"}
            size={props.size ?? "small"}
            error={Boolean(props.error)}
            helperText={props.error ?? props.hint}
        >
            {props.options.map((o) => {
                return (
                    <MenuItem
                        key={"item" + o}
                        value={o}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {o}
                    </MenuItem>
                );
            })}
        </TextField>
    );
}
